import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/suppliers`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/suppliers/${id}?include=organization,tags,allowedLocations,imports`,
      options
    )
    .then((response) => {
      let supplier = jsona.deserialize(response.data);
      delete supplier.links;
      return supplier;
    });
}

function add(supplier) {
  const payload = jsona.serialize({
    stuff: supplier,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/suppliers?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(supplier) {
  const payload = jsona.serialize({
    stuff: supplier,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/suppliers/${supplier.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/suppliers/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
